"use client";
import SectionPage from "@/components/common/section-page";
import EspaceProTitleCard from "@/components/common/espace-pro-title-card";

export default function Home() {

    return (
        <div className={"flex flex-col gap-6 pb-6 mb-8"}>


            <EspaceProTitleCard title={"Ressources Humaines, Formation et Perfectionnement"}
                                middleBreadcrumbs={[
                                    {title: "L'Office du Tourisme", link: "/espace-pro/office-de-tourisme"},
                                ]}
                                description={"Découvrez l’équipe de l’Office de Tourisme et les missions que nous menons, en faveur du développement touristique de la destination COTE D’IVOIRE"}/>

            {/* Nature & Biodiversité */}
            <SectionPage sectionType="lg">

                <p className={"text-normal mb-8"}>
                    Directeur : Madame <strong>TRAORE Kiya Colette</strong>
                    <br/>
                    <br/>
                    Ce pôle assure la gestion quotidienne de l’organisme en termes administratif et des ressources
                    humaines. Il est chargé de :
                </p>

                <div className={"text-normal mb-8"}>
                    <ul className="list-disc list-inside text-lg mt-8">
                        <li className="li2">Gérer les ressources humaines de Côte d’Ivoire Tourisme ;</li>
                        <li className="li2">Mettre en œuvre la politique sociale de l’établissement</li>
                        <li className="li2">Assurer la formation professionnelle continue du personnel et d’organiser
                            les stages au profit des acteurs du tourisme.
                        </li>
                    </ul>
                </div>

            </SectionPage>

        </div>
    );
}
